
{
  "title": "Confirm delete",
  "message": "Are you sure you want to delete?",
  "actions": {
    "delete": "Delete"
  }
}
